import { Form, FormBuilder, FormEdit } from '@formio/react'
import { useState, useRef } from 'react'
import { CCol, CRow, CCard, CCardBody, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CButtonGroup, CCardTitle, CCardText, CCardImage, CButton, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormSelect, CCardHeader, CCardFooter } from '@coreui/react'
import { CModal, CModalBody, CModalHeader, CModalFooter, CFormLabel } from '@coreui/react'

import Modal from 'react-bootstrap/Modal'
import { Button, Card, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import './Builder.css'
import axios from 'axios'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionBank from '../../services/general/saveQuestionBank.api'
import { useEffect } from 'react'

const Builder = () => {
  const [jsonSchema, setSchema] = useState({ components: [] })
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const selectedDiagnosis = useRef('')
  //const [diagnosis, setDiagnosis] = useState(["Select Diagnosis","Cognitive","Neuropsychiatric","Headache","Multiple sclerosis","General Questions","Default Questions"])
  const formioOptions = {
    noDefaultSubmitButton: true,
    builder: {
      basic: {
        title: 'Basic Options',
        weight: 10,
        components: {
          question: {
            title: 'Questions - Select Option/ Dropdown',
            schema: {
              label: '',
              type: 'select',
            },
          },
          questionText: {
            title: 'Questions - Text Input',
            schema: {
              label: '',
              type: 'textfield',
            },
          },
          questionNumber: {
            title: 'Questions - Number Input',
            schema: {
              label: '',
              type: 'number',
            },
          },
        },
      },
    },
    //   builder:{
    //     basic: {
    //       title: 'Basic',
    //       weight: 0,
    //       default: true,
    //       components: {
    //         select:{
    //           title:"Questions",
    //           key:"select",
    //           icon: 'terminal',
    //           schema: {
    //             label: 'Question',
    //             type: 'select',

    //             input: true
    //         }
    //         }
    //       }
    //     },

    // }
  }

  const [diagnosisData, setDiagnosisData] = useState([])
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)
  }

  const handleDiagnosisChange = async (e) => {
    selectedDiagnosis.current = e.label
    let a = await SaveQuestionBank('', selectedDiagnosis.current, '')
    if (a.d == '') {
      setSchema({ components: [] })
    } else {
      let temp = JSON.parse(a.d)
      setSchema(temp)
    }
  }

  useEffect(() => {
    let resp = getData()
  }, [])

  const handleSave = async () => {
    // let payload = {
    //   questions:JSON.stringify(jsonSchema),

    //   diagnosis:selectedDiagnosis,
    //   mode:"INSERT"
    // }
    // const config = {
    //   method: 'post',
    //   url: 'http://localhost:50252/webservice/Charts.asmx/QuesitonBank',
    //   contentType: 'application/json',
    //   headers: {
    //     'Content-Type': 'application/json; charset=utf-8',
    //    // Authorization: `Bearer ${cookie}`,
    //   },
    //   data: JSON.stringify(payload),
    // }
    let a = await SaveQuestionBank(JSON.stringify(jsonSchema), selectedDiagnosis.current, 'INSERT')
    alert('Form Saved')
  }
  return (
    <>
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <div className="form-row">
            <CCard title="Diagnosis" className="my-4">
              <CCardHeader>
                <CCardTitle className="text-center">Select Diagnosis From Below</CCardTitle>
              </CCardHeader>
              <CCardBody>
                {/* <div className="col-md-6">

        <label>Diagnosis :</label>
        </div>
        <div  className="my-2">
    <select className="form-control" name="city" defaultValue={diagnosis[0]} onChange={(e)=>{selectedDiagnosis = e.target.value}}>
      {diagnosis.map((obj,key) => {
       return <option  key={key} value={key}>{obj}</option>
      })}
                                        
                                      
                                        
                                    </select>
                                    </div> */}
                <div className="mb-3">
                  <CFormLabel>Select Diagnosis</CFormLabel>

                  <Select
                    onChange={(e) => {
                      handleDiagnosisChange(e)
                    }}
                    options={diagnosisData}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
              </CCardBody>
              <CCardFooter>
                <Button variant="primary" onClick={handleShow}>
                  View Form
                </Button>
                <Button variant="primary" onClick={handleSave} style={{ marginLeft: '10px' }}>
                  Save Form
                </Button>
              </CCardFooter>
            </CCard>
          </div>
        </div>
      </div>

      <FormBuilder options={formioOptions} form={jsonSchema} onChange={(schema) => setSchema(schema)} />

      {/* <Card title="Form JSON Schema" className="my-4">
      <Card.Body>
        <Card.Title className="text-center">Form JSON Schema</Card.Title>
          <ReactJson src={jsonSchema} collapsed={true}></ReactJson>
      </Card.Body>
      </Card> */}
      {/* <Card className="my-4">
      <Card.Body>
        <Card.Title className="text-center">Form Render</Card.Title>
        
      </Card.Body>
      </Card> */}

      <div className="row">
        <div className="col-md-6 offset-md-3">
          <div className="my-4"></div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Form Render</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form form={jsonSchema} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default Builder
